<template>
  <div board__pagination>
    <div class="page-group" v-for="(page, idx) in displayPage" :key="`page_${idx}`">
      <span class="page-item" 
        @click.prevent="onChange({ currentPage: page })" 
        :class="{'active': page == currentPage}"> 
        {{ page }} 
      </span>
    </div>
    <i class="page-btn prev" @click.prevent="onPrev" />
    <i class="page-btn next" @click.prevent="onNext" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1,
      displayPage: [],
      totalPage: 2,
      firstPage: 1,
      pageSize: 5,
      offset: 10
    }
  },
  created() {

  },
  methods: {
    init({ 
      firstPage = this.firstPage, 
      currentPage = this.currentPage, 
      totalPage = this.totalPage, 
      pageSize = this.pageSize,
      offset = this.offset,
    } = {} ) {
      this.currentPage = currentPage
      this.pageSize = pageSize
      this.totalPage = Math.ceil(totalPage/offset)
      this.displayPage = this.getPages()
      console.log("init pagination")
    },
    getPages() {
      let arr = []
      let cal = this.currentPage % this.pageSize
      let start = this.currentPage - (( cal == 0 ? this.pageSize : cal ) -1)
      let end = start + this.pageSize
      for( start; start < end; start++) {
        if(start > this.totalPage ) break;
        else arr.push(start)
      }
      return (arr)
    },
    setPage({ currentPage = this.currentPage } = {}) {
      if(currentPage > this.totalPage || currentPage < this.firstPage || _.isNaN(currentPage)) return
      else this.currentPage = currentPage
      
      if(!_.includes(this.displayPage, this.currentPage)) {
        this.displayPage = this.getPages()
        this.onChange()
      }
    },
    onChange({ currentPage = this.currentPage } = {} ) {
      this.currentPage = currentPage
      this.$emit('pageChange', currentPage)
    },
    onPrev() {  this.setPage({ currentPage: _.min(this.displayPage)-1 }) },
    onNext() {  this.setPage({ currentPage: _.max(this.displayPage)+1 })  }
  }
}
</script>

<style lang="less">
.statv_page_bg {
  min-height: 0 !important;
} 

div[board__pagination] {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  .page-group {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    order: 2;
    .page-item {
      font-family: "BebasNeue";
      cursor: pointer;
      color: #8F8F8F;
      padding: 0 25px;
      &.active {
        font-weight: bold;
        color:#ff6400;
      }
    }
  }
  .page-btn {
    display: flex;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    width: 12px;
    height: 14px;
    margin: 0 16px;
    cursor: pointer;
    &.prev {
      order: 1;
      background-image: url("~@/assets/image/board/arrow_left.png");
    }
    &.next {
      order: 3;
      background-image: url("~@/assets/image/board/arrow_left.png");
      transform: rotate(180deg);
    }
  }
}

.m div[board__pagination]  {
  .page-group {
    font-size: 37px;
    .page-item {
      padding: 0 35px;
      &.active {
        font-weight: normal;
      }
    }
  }
  .page-btn {
    width: 16px;
    height: 15px;
  }
}
</style>